import { render, staticRenderFns } from "./AllTeams.vue?vue&type=template&id=e913d01c&"
import script from "./AllTeams.vue?vue&type=script&lang=js&"
export * from "./AllTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports